import { Box, Typography, styled } from "@mui/material";
import { colors } from "../../theme/colors";

export const StepCounter = styled(Typography)({
  fontSize: "16px",
  color: colors.text.secondary,
  fontFamily: "Nunito",
  fontWeight: 400,
  display: "inline",
  marginLeft: "8px",
});

export const RejectionCommentBox = styled(Box)({
  backgroundColor: colors.background.red,
  borderRadius: "16px",
  padding: "16px",
  margin: "32px 0",
});

export const RejectionCommentTitle = styled(Typography)({
  fontSize: "18px",
  fontWeight: 600,
  color: colors.text.error,
  fontFamily: "Sora",
  marginBottom: "4px",
});

export const RejectionCommentText = styled(Typography)({
  fontSize: "16px",
  color: colors.text.error,
  fontFamily: "Nunito",
  lineHeight: "24px",
});
